<template>
    <div>
        <template v-if="is_attending">
            <button class="btn btn-block btn-xs btn-danger mb-1" @click="changeAttendace">{{cancelBookingText}}
                {{showName ?
                '('+this.member.fullname+')' : ''}}
            </button>
        </template>
        <template v-else-if="closed">
            <button class="btn btn-block btn-xs btn-danger disabled mb-1">Closed</button>
        </template>
        <template v-else-if="!canAttend">
            <button class="btn btn-block btn-xs btn-danger disabled mb-1">Not Eligible {{showName ?
                '('+this.member.fullname+')' : ''}}
            </button>
        </template>
        <template v-else-if="capacityRemaining < 1">
            <button class="btn btn-block btn-xs btn-danger disabled mb-1">Full</button>
        </template>
        <template v-else>
            <button class="btn btn-block btn-xs btn-success mb-1" @click.prevent="changeAttendace">{{bookNowText}} {{showName ?
                '('+this.member.fullname+')' : ''}}
            </button>
        </template>
    </div>
</template>
<script>
    export default {
        name: "registration-category-member-enter-button",
        props: {
            member: {
                type: Object,
                default: () => ({}),
                required: true
            },
            regCategoryId: {
                default: null,
            },
            capacityRemaining: {
                type: Number,
                required: false,
                default: 1
            },
            occasionId: {
                default: null,
            },
            showName: {
                type: Boolean,
                default: false
            },
            closed: {
                type: Boolean,
                default: false
            },
            canAttend: {
                type: Boolean,
                default: true
            },
            bookNowText: {
                type: String,
                required: true
            },
            cancelBookingText: {
                type: String,
                required: true
            },
            reloadPage: {
                type: Boolean,
                required: false,
                default: false
            },

        },
        data() {
            return {
                is_attending: this.member.attendees.length && this.member.attendees.some(attendee => attendee.registration_category_id == this.regCategoryId),
            }
        },
        methods: {
            changeAttendace() {
                axios.put(`/api/v0/attendees/${this.regCategoryId}/attendance`, {
                    'member_id': this.member.id,
                    'is_attending': !this.is_attending,
                    'occasion_id': this.occasionId,
                }).then(response => {
                    if (response.data.status == 'error') {
                        alert(response.data.message);

                        return;
                    }

                    if (this.redirectUrl) {
                        location.replace(this.redirectUrl);
                    }

                    if (this.reloadPage) {
                        location.reload();
                    }

                    this.is_attending = !this.is_attending;
                }).catch(error => {
                    alert('There was a problem saving this members attendance.  Please contact your support administrator');
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/Members/Utilities/Buttons/EnterRegistrationCategoryButton.vue